import { store } from "@/store/store";
import { canales_entrada } from "@/shared/dtos/canales_entrada";
import {
  VuexModule,
  Mutation,
  getModule,
  Module,
  Action,
} from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";

@Module({
  namespaced: true,
  name: "canalesEntradaModule",
  store,
  dynamic: true,
})
class canalesEntradaModule extends VuexModule {
  public canalesEntrada: canales_entrada[] = [];
  public canalEntrada: canales_entrada = new canales_entrada();

  @Action({ commit: "onGetCanalesEntrada" })
  public async getCanalesEntrada() {
    return await ssmHttpService.get(API.canales_entrada);
  }

  @Action({ commit: "onGetCanalEntrada" })
  public async getCanalEntrada(id: any) {
    return await ssmHttpService.get(API.canales_entrada + "/" + id);
  }

  @Action
  public async guardarCanalEntrada(item: canales_entrada) {
    return await ssmHttpService.post(API.canales_entrada, item.toJson());
  }

  @Action
  public async modificarCanalEntrada(item: canales_entrada) {
    return await ssmHttpService.put(API.canales_entrada + "/" + item.id, item.toJson());
  }

  @Action
  public async eliminarCanalEntrada(item: canales_entrada) {
    return await ssmHttpService.delete(API.canales_entrada + "/" + item.id, null, false);
  }

  @Mutation
  public onGetCanalesEntrada(res: canales_entrada[]) {
    this.canalesEntrada = res ? res.map((x) => new canales_entrada(x)) : [];
  }

  @Mutation
  public onGetCanalEntrada(res: canales_entrada) {
    this.canalEntrada = new canales_entrada(res);
  }
}

export default getModule(canalesEntradaModule);
